<template>
  <list-layout id="promatch-quotes">
    <template #leftSidebar>
      <orders-menu />
      <br>
      <orders-search-widget-form />
    </template>

    <template #heading>
      <h1>{{ getContentItem("quotes") }}</h1>
    </template>

    <template #subTitle>
      <div class="subtitle" v-html="getContentItem('quotesSubTitle')" />
    </template>

    <template #filters>
      <b-row class="filter-row">
        <b-col md="6">
          <b-form-group label-cols="3" :label="getContentItem('perPage')" label-for="per-page">
            <b-form-select
              id="per-page"
              v-model="pagination.perPage"
              :options="pagination.perPageList"
              size="lg"
              class="form-control"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-sr-only :label="getContentItem('filter')" label-for="filter">
            <b-form-input id="filter" v-model="textFilter" :placeholder="getContentItem('filter')" />
          </b-form-group>
        </b-col>
      </b-row>
    </template>

    <template #table>
      <div>
        <b-table
          id="quotes-table"
          hover
          striped
          stacked="md"
          class="blue"
          :items="loadQuotes"
          :fields="columns"
          :no-provider-sorting="true"
          :no-provider-filtering="true"
          :current-page="pagination.currentPage"
          :per-page="pagination.perPage"
          :filter="textFilter"
          :filter-function="filterGrid"
          show-empty
          empty-text="No Quotes Found"
          :busy="isLoadingQuotes"
        >
          <template slot="table-busy">
            <loading-spinner class="mx-auto" />
          </template>
          <template slot="QuoteNumber" slot-scope="row">
            <router-link
              :to="{ name: 'QuoteDetail', query: { quoteNumber: row.item.QuoteNumber }}"
            >
              {{ row.item.QuoteNumber }}
            </router-link>
          </template>
          <template slot="DateQuoted" slot-scope="row">
            {{ getLocalDate(row.item.DateQuoted) }}
          </template>
          <template slot="ExpireDate" slot-scope="row">
            {{ getLocalDate(row.item.ExpireDate) }}
          </template>
        </b-table>
        <b-row v-if="pagination.totalRows > 0">
          <b-col
            id="paginationDisplay"
            md="6"
            class="pull-left"
          >
            {{ format(getContentItem('showingPagination'), paginationFirstRecord, paginationLastRecord, pagination.totalRows) }}
          </b-col>
          <b-col md="6">
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalRows"
              :per-page="pagination.perPage"
              class="pull-right"
              aria-controls="quotes-table"
            />
          </b-col>
        </b-row>
      </div>
    </template>
  </list-layout>
</template>

<script>
  import { mapGetters } from "vuex";

  import moment from "moment";

  import { ErrorLogService, QuoteService } from "@/services/";
  import {
    formatDateTime,
    paginationMixin,
    stringHelper
  } from "@/components/mixins";

  import { ListLayout } from "@/components/layouts";

  import { OrdersMenu, OrdersSearchWidgetForm } from "@/components/SubMenus";
  import { LoadingSpinner } from "@/components";

  export default {
    name: "Quotes",
    components: {
      ListLayout,
      OrdersMenu,
      OrdersSearchWidgetForm,
      LoadingSpinner
    },
    mixins: [formatDateTime, paginationMixin, stringHelper],
    data: () => ({
      columns: [
        { key: "QuoteNumber", labelKey: "orderNumber", sortable: false },
        { key: "DateQuoted", labelKey: "date", sortable: false },
        { key: "DealerCode", labelKey: "dealerCode", sortable: false },
        { key: "QuotedTo", labelKey: "quotedTo", sortable: false },
        { key: "ExpireDate", labelKey: "expireDate", sortable: false }
      ],
      textFilter: null,
      isLoadingQuotes: false
    }),
    computed: {
      ...mapGetters(["user", "getContentItem", "activeAccountId"])
    },
    methods: {
      loadQuotes: function() {
        this.isLoadingQuotes = true
        const params = {
          accountId: this.activeAccountId,
          userId: this.user.UserId,
          dealerCode: this.user.DealerCode,
          pageNumber: this.pagination.currentPage,
          pageSize: this.pagination.perPage
        };

        return QuoteService.getQuotes(params)
          .then(result => {
            const data = result.data;

            this.pagination.totalRows = data.Total;

            return data.Items;
          })
          .catch(err => {
            ErrorLogService.LogException(err);

            return [];
          })
          .finally(() => {
            this.isLoadingQuotes = false
          });
      },

      filterGrid(row) {
        var filter = new RegExp(this.textFilter, "i");
        for (let key in row) {
          if (filter.test(String(row[key]))) {
            return true;
          }
        }
        return false;
      }
    }
  };
</script>

<style lang="scss">
#promatch-quotes {
  .subtitle {
    margin-bottom: 2rem;
  }

  .filter-row {
    border-top: 1px solid $light-gray;
    padding: 1rem 0;
    margin: 0;

    .form-row {
      align-items: center;
    }

    .form-group {
      margin-bottom: 0;
    }
  }

  #per-page {
    width: 90px;
  }
}
</style>
